exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host(.hrt) .testFont {\n  color: #ff0000; }\n\n:host(.dar) .testFont {\n  color: #00ffff; }\n\n/* add class=\"{{theme}}\" to selector markup */\n.active-buyers {\n  background: url(\"/assets/images/icons/haart/Roundal-plain-HRT.png\") no-repeat center;\n  background-size: contain;\n  height: 90px;\n  width: 90px;\n  text-align: center;\n  padding-top: 15px;\n  margin-right: 10px;\n  float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/central/central.component.scss
// module id = ../../../../../src/app/central/central.component.scss
// module chunks = 1